import "@/App.css";
import { QueryClientProvider } from "@tanstack/react-query";
import AppRouter from "./app/router";
import { queryClient } from "./app/queryClient";
import AuthHydrationGate from "./components/AuthHydrationGate";
import { Toaster } from "sonner";

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthHydrationGate>
        <div className="App min-h-screen bg-[#050505] text-[#f5f5f5]">
          <AppRouter />
          <Toaster
            theme="dark"
            position="top-center"
            toastOptions={{
              style: {
                background: "rgba(5,5,5,0.92)",
                border: "1px solid rgba(255,255,255,0.12)",
                color: "#f5f5f5",
                fontFamily: "Space Mono, monospace",
                fontSize: "12px",
                letterSpacing: "0.05em",
                backdropFilter: "blur(20px)",
              },
            }}
          />
        </div>
      </AuthHydrationGate>
    </QueryClientProvider>
  );
}

export default App;
